import { render, staticRenderFns } from "./TemplateSelectionDraftsPanel.vue?vue&type=template&id=dd78fd7e&scoped=true"
import script from "./TemplateSelectionDraftsPanel.vue?vue&type=script&lang=js"
export * from "./TemplateSelectionDraftsPanel.vue?vue&type=script&lang=js"
import style0 from "./TemplateSelectionDraftsPanel.vue?vue&type=style&index=0&id=dd78fd7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd78fd7e",
  null
  
)

export default component.exports